import { useState, useEffect } from "react";
import "./AppSidebar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { APP_MENUS, selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import { Workspace } from "winslow-core";
import { apiCreateWorkspaceHRIS, apiCreateWorkspaceTestHRIS, apiGetWorkspace } from "../../../api";
import { Button } from "../../../ds2/components";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import "../../../ds2/components/SidebarMenu.css";
import config from "environment";
import { EmployeeProfileSidebar } from "../../employee-profile-sidebar/EmployeeProfileSidebar";

const NOT_PROD = config.environment !== "production";

type AppSidebarProps = {

}

export const AppSidebar = ({} : AppSidebarProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates)

    const [workspace, setWorkspace] = useState<Workspace | null>( null);
    const [testSystem, setTestSystem] = useState<string>("");

    useEffect(() => {
        const workspaceId = storeUser?.currentWorkspaceId;

        (async () => {
            const workspace = await apiGetWorkspace(workspaceId);
            setWorkspace(workspace);
        })();

    }, [storeUser?.currentWorkspaceId]);

    const createNativeHRIS =  async () => {
        const workspace = await apiCreateWorkspaceHRIS(storeUser?.currentWorkspaceId);

        if (!workspace) {
            toast("Error creating HRIS", toastFail);
            return;
        }

        setWorkspace(workspace);
    }

    const createTestHRIS = async () => {
        const workspace = await apiCreateWorkspaceTestHRIS(storeUser?.currentWorkspaceId, testSystem);

        if (!workspace) {
            toast("Error creating test HRIS", toastFail);
            return;
        }

        setWorkspace(workspace);
    }

    const getSelectedItemClassName = (menu: string) => {
        if (uiStates.appSelectedMenu === menu) {
            return "ds2-sidebar-item ds2-sidebar-item-selected";
        }
        return "ds2-sidebar-item";
    }

    const thirdPartyHRIS = workspace?.mergeIntegration || workspace?.apiDeckIntegration; 

    console.log("[AppSidebar] uiStates.appSelectedMenu: ", uiStates.appSelectedMenu);

    return (
        <div className="ds2-sidebar">
            {workspace?.hasNativeHRIS && !thirdPartyHRIS && 
                <>
                    <div className="ds2-sidebar-section">
                        Manage
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.EMPLOYEES)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEES}));
                            navigate("/app/employee-records")
                        }}
                    >
                        Employees
                    </div>

                    {/* <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEE_NEW}));
                            navigate("/app/employee-records/new")
                        }}
                    >
                        Add Employee
                    </div> */}

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.TIME_OFF)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.TIME_OFF}));
                            navigate("/app/time-off")
                        }}
                    >
                        Time Off
                    </div>

                   

                    {/* <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.DOCUMENTS}));
                            navigate("/app/documents")
                        }}
                    >
                        Documents
                    </div> */}

                    <div 
                        className="ds2-sidebar-section"
                        style={{marginTop: "24px"}}
                    >
                        Admin
                    </div>
                    <div 
                        className={getSelectedItemClassName(APP_MENUS.CUSTOM_PROPERTIES)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.CUSTOM_PROPERTIES}));
                            navigate("/app/custom-properties/")
                        }}
                    >
                        Customize
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.VIBES)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.VIBES}));
                            navigate("/app/workflow/vibes/")
                        }}
                    >
                         Vibe 
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.WORKFLOWS)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.WORKFLOWS}));
                            navigate("/app/workflows")
                        }}
                    >
                        Workflows
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.FLATTEN)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.FLATTEN}));
                            navigate("/app/employee-records/flatten")
                        }}
                    >
                        Export
                    </div>

                    <div 
                        className="ds2-sidebar-section"
                        style={{marginTop: "24px"}}
                    >
                        Company
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.DIRECTORY)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.DIRECTORY}));
                            navigate("/app/company/directory")
                        }}
                    >
                        Directory
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.COMPANY_CALENDAR)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.COMPANY_CALENDAR}));
                            navigate("/app/company/calendar")
                        }}
                    >
                        Calendar
                    </div>



                    <div 
                        className="ds2-sidebar-section"
                        style={{marginTop: "24px"}}
                    >
                        You
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.PAY_STUBS)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.PAY_STUBS}));
                            navigate("/app/employee/pay-stubs")
                        }}
                    >
                        Pay Stubs
                    </div>

                    

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.BENEFITS)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.BENEFITS}));
                            navigate("/app/employee/benefits")
                        }}
                    >
                        Benefits
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.EMPLOYEE_TIME_OFF)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEE_TIME_OFF}));
                            navigate("/app/employee/time-off")
                        }}
                    >
                        Time Off
                    </div>

                    <div 
                        className={getSelectedItemClassName(APP_MENUS.EMPLOYEE_WORKFLOWS)}
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEE_WORKFLOWS}));
                            navigate(`/app/workflows/${storeUser?.employeeRecordId}`)
                        }}
                    >
                        Workflows
                    </div>
                    

                </>
            }
            {workspace && !workspace?.hasNativeHRIS && 
                <>
                    {!thirdPartyHRIS && 
                        <div 
                            className="ds2-sidebar-section" 
                            style={{display: "flex", gap: "10px", flexDirection: "column"}}
                        >
                            <Button
                                variant="primary"
                                onClick={createNativeHRIS}
                                label="Create HRIS"
                            />

                            {NOT_PROD && 
                                <> 
                                    <Button
                                        variant="primary"
                                        onClick={createTestHRIS}
                                        label="Create Test HRIS"
                                    />
                                    <input type="text" placeholder="test system" onChange={(e) => setTestSystem(e.target.value)} />
                                </>
                            }
                                
                        </div>
                    }
                    {thirdPartyHRIS && 
                        <div className="ds2-sidebar-section">
                            You are already using a third party HRIS
                        </div>
                    }
                </>
            }
           
        <EmployeeProfileSidebar />
        
        </div>
    )
}